"use client";

import { cn } from "@/lib/utils";

type CreditAmountOptionProps = {
  amount: string;
  description?: string;
  selected: boolean;
  onSelect: () => void;
};

export const CreditAmountOption = ({ amount, description, selected, onSelect }: CreditAmountOptionProps) => (
  <button
    type="button"
    aria-pressed={selected}
    onClick={onSelect}
    className={cn(
      "flex h-28 flex-col items-start justify-between rounded-[5px] border-0 px-3 py-3 text-left transition-colors",
      "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden",
      selected
        ? "bg-[#000099] text-white"
        : "bg-[#F5F3EE] text-foreground hover:bg-[#F0EEE9] dark:bg-muted/30 dark:hover:bg-muted/60",
    )}
  >
    <span className="text-3xl font-normal tracking-tight">{amount}</span>
    {description ? (
      <span className={cn("text-sm", selected ? "text-white/90" : "text-muted-foreground")}>{description}</span>
    ) : null}
  </button>
);
